$(window).on("load", function(){
  $(".js-twentytwenty").twentytwenty({
  	default_offset_pct: 0.8,
  	no_overlay: true,
  	click_to_move: true 
  });
});